<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { sellerService } from "../../../services/saleservice/seller.service";
import { sellerTypeService } from "../../../services/saleservice/sellertype.service";
import List from "../../../components/list";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Sellers List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    List 
  },
  data() {
    return {
      sellerDataList: {},
      typeDataList: {},
      fetchingStats: false,
      title: "Sellers List",

    };
  },
  mounted() {
  
    this.loadingSellerTypeData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = `?clause={"clause":{"and":{"sellers.type_id":{"value":2}}}}`) {

      this.fetchingStats = false;
      sellerService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.sellerDataList = response;
        });
    },

    loadingSellerTypeData: function() {
      sellerTypeService.getList()
        .then(response => {
          this.typeDataList = response;

          console.log(JSON.stringify(this.typeDataList));

        });
    },

    deleted: function(id) {
      sellerService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "seller-add",
          });
    },

    moreClicked: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.approve'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
                
            sellerService.suspend({id}).then(response => {
              if(response.status == 200) {
                
                // this.loadingSaleTransferData();
                
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.denie'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {

            sellerService.suspend({id}).then(response => {
              if(response.status == 200) {
                
                // this.loadingSaleTransferData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      }
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'seller-add'}" :title="`${$t('menuitems.seller.text')} (${$t('menuitems.seller.agency')})`"/>
    <List v-bind:dataList="sellerDataList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'suspend', color: true}]"
          v-bind:fields="[`code: ${$t('seller.code')}`, `type: ${$t('seller.type')}`, `name: ${$t('seller.name')}`, 
            `phone_no_1: ${$t('seller.phone-no')}`, `email: ${$t('seller.email')}`, `address: ${$t('seller.address')}`, `suspend: ${$t('general.status')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'seller-edit'}"
          v-bind:view="{link: 'seller-view'}"
          v-bind:more="{
            sub: [{
              name: 'setting.security.user.suspend', icon: 'bx bx-no-entry', action: 'suspend', column: 'id', show: {column: 'user_suspend_id', value: 1}
            },{
              name: 'setting.security.user.unsuspend', icon: 'bx bx-check-circle', action: 'unsuspend', column: 'id', show: {column: 'user_suspend_id', value: 2}
            }] 
          }"
          @more="moreClicked"
          v-bind:filter="{
            search: ['sellers.code', 'sellers.name', 'sellers.name_en', 'sellers.phone_no_1', 'sellers.phone_no_2'],
            dropdown: [{
              title: 'seller.type',
              field: 'sellers.type_id',
              data: this.typeDataList.data,
              width: 2,
              default: 2
            }]
          }"
          
    />      
  </Layout>
</template>